export default "__VITE_ASSET__ygQmOUoE__"